if (!customElements.get('wheelparts-footer')) {
  customElements.define(
    'wheelparts-footer',
    class WheelpartsFooter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        const syncPanels = () => {
          this.querySelectorAll('[data-footer-toggle]').forEach((button) => {
            const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
            if (this.mobileQuery.matches) {
              button.setAttribute('aria-expanded', 'false');
              panel?.setAttribute('aria-hidden', 'true');
            } else {
              button.setAttribute('aria-expanded', 'true');
              panel?.setAttribute('aria-hidden', 'false');
            }
          });
        };

        this.querySelectorAll('[data-footer-toggle]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!this.mobileQuery.matches) return;
            const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
            const open = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
            panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
          }, options);
        });

        this.mobileQuery.addEventListener?.('change', syncPanels, options);
        syncPanels();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.dataset.initialized = 'false';
      }
    },
  );
}
